var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.shoppingCartIsOpen
    ? _c(
        "div",
        [
          _c("loading-overlay", {
            attrs: {
              active: _vm.submissionInProgress,
              loader: "dots",
              color: "#1A74DB",
              height: "30",
              width: "100%",
              opacity: "0.85",
            },
            on: {
              "update:active": function ($event) {
                _vm.submissionInProgress = $event
              },
            },
          }),
          _vm._v(" "),
          _c("HardwareOnlyModal", { ref: "hardwareOnlyModal" }),
          _vm._v(" "),
          _c("div", {
            staticClass: "cover row",
            on: { click: _vm.setShoppingCartToClosed },
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "col xs-12 md-4 relative",
              attrs: { id: "shopping-cart" },
            },
            [
              _c(
                "div",
                { staticClass: "flex flex-between", attrs: { id: "header" } },
                [
                  _c("div", { attrs: { id: "title" } }, [
                    _vm._v(_vm._s(_vm.webstoreContent.shoppingBag)),
                  ]),
                  _vm._v(" "),
                  _c("div", {
                    staticClass: "close",
                    attrs: { id: "close-shopping-cart" },
                    on: { click: _vm.setShoppingCartToClosed },
                  }),
                ]
              ),
              _vm._v(" "),
              [
                _vm.showContractDisclaimer && !_vm.hasContractExpired
                  ? _c("div", { staticClass: "col notification" }, [
                      _c("div", { staticClass: "cart-notification bold" }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.contractDisclaimer) +
                            "\n                "
                        ),
                      ]),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.isShoppingCartEmpty
                  ? _c("OffersInCart")
                  : _c("div", { staticClass: "col xs-6 notification" }, [
                      _c("div", { staticClass: "cart-notification" }, [
                        _vm._v("0 items in cart."),
                      ]),
                    ]),
                _vm._v(" "),
                !_vm.isShoppingCartEmpty
                  ? _c(
                      "div",
                      { staticClass: "sticky-wrapper" },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "col xs-12",
                            attrs: { id: "subtotal" },
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.webstoreContent.subtotal) +
                                ": " +
                                _vm._s(_vm.currencySymbol.toUpperCase()) +
                                _vm._s(_vm.subtotal.toLocaleString("en-US"))
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("v-button", {
                          attrs: {
                            position: "right",
                            mobile: "12",
                            tablet: "12",
                            desktop: "4",
                            styling: "primary",
                            textAlign: "center",
                            disabled: _vm.isShoppingCartEmpty,
                          },
                          on: { onClickEvent: _vm.submitHandler },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "content",
                                fn: function () {
                                  return [
                                    _c("span", [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(
                                            _vm.webstoreContent
                                              .proceedToCheckout
                                          ) +
                                          "\n                        "
                                      ),
                                    ]),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            790302675
                          ),
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }